var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.consequences.length && _vm.readOnly
        ? _c("h5", [_vm._v("No hay consecuencias")])
        : _vm._e(),
      !_vm.readOnly
        ? _c(
            "form",
            {
              staticClass: "container",
              attrs: { autocomplete: "off" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-5" },
                  [
                    _c(
                      "vs-select",
                      {
                        staticClass: "w-100",
                        attrs: {
                          autocomplete: "",
                          label: "Tipo ",
                          name: "type",
                          placeholder: "Seleccione..."
                        },
                        model: {
                          value: _vm.type,
                          callback: function($$v) {
                            _vm.type = $$v
                          },
                          expression: "type"
                        }
                      },
                      _vm._l(_vm.consequencesTypes, function(item) {
                        return _c("vs-select-item", {
                          key: item.id,
                          attrs: {
                            autocomplete: "off",
                            value: item,
                            text: item.nombre
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-5" },
                  [
                    _c(
                      "vs-select",
                      {
                        staticClass: "w-100",
                        attrs: {
                          disabled: !_vm.type,
                          autocomplete: "",
                          label: "Proceso",
                          name: "process",
                          placeholder: "Seleccione..."
                        },
                        model: {
                          value: _vm.process,
                          callback: function($$v) {
                            _vm.process = $$v
                          },
                          expression: "process"
                        }
                      },
                      _vm._l(_vm.filteredConsequences, function(item) {
                        return _c("vs-select-item", {
                          key: item.id,
                          attrs: {
                            autocomplete: "",
                            value: item,
                            text: item.descripcion
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2 mt-3" },
                  [
                    _c("vs-icon", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Agregar consecuencia",
                          expression: "'Agregar consecuencia'"
                        }
                      ],
                      staticClass: "mt-5 w-100 cursor-pointer",
                      attrs: {
                        icon: "add_circle_outline",
                        size: "medium",
                        color: "success",
                        "data-cy": "add-consequence"
                      },
                      on: { click: _vm.addConsequence }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e(),
      _c("div", { staticClass: "row mt-5" }, [
        _c("div", { staticClass: "col-12" }, [
          _vm.consequences.length
            ? _c(
                "table",
                { staticClass: "table text-center table-responsive" },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("th", { attrs: { scope: "col" } }, [_vm._v("Tipo")]),
                      _c("th", { attrs: { scope: "col" } }, [
                        _vm._v("Proceso")
                      ]),
                      !_vm.readOnly
                        ? _c("th", { attrs: { scope: "col" } }, [
                            _vm._v("Acciones")
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _c(
                    "tbody",
                    _vm._l(_vm.consequences, function(consequence) {
                      return _c(
                        "tr",
                        {
                          key: consequence.key,
                          attrs: { name: "tr-" + consequence.key }
                        },
                        [
                          _c("td", [_vm._v(_vm._s(consequence.estado))]),
                          _c("td", [_vm._v(_vm._s(consequence.proceso))]),
                          !_vm.readOnly
                            ? _c("td", [
                                _c(
                                  "div",
                                  { staticClass: "d-flex" },
                                  [
                                    _c("vs-icon", {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: "Configurar consecuencia",
                                          expression:
                                            "'Configurar consecuencia'"
                                        }
                                      ],
                                      staticClass: "w-100 cursor-pointer",
                                      attrs: {
                                        icon: "settings",
                                        size: "medium",
                                        color: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.configureConsequenceModal(
                                            consequence
                                          )
                                        }
                                      }
                                    }),
                                    _c("vs-icon", {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: "Eliminar consecuencia",
                                          expression: "'Eliminar consecuencia'"
                                        }
                                      ],
                                      staticClass: "w-100 cursor-pointer",
                                      attrs: {
                                        icon: "remove_circle_outline",
                                        size: "medium",
                                        color: "danger"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeConsequence(
                                            consequence
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
            : _vm._e()
        ])
      ]),
      _c(
        "b-modal",
        {
          ref: "consecuencia",
          attrs: {
            id: "consecuencia",
            size: "lg",
            title: _vm.modalTitle,
            "hide-footer": "",
            "no-close-on-backdrop": "",
            centered: ""
          }
        },
        [
          _c("consequence", {
            ref: "consecuencemodal",
            attrs: {
              consequence: _vm.consequence,
              processconfig: _vm.processconfig,
              reference: _vm.reference,
              readonly: _vm.readOnly
            },
            on: {
              close: function($event) {
                return _vm.$bvModal.hide("consecuencia")
              },
              configurate: _vm.configurateConsecuence
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }